<template lang="pug">

  v-container(fluid)
    #my_main_wrapper.pt-6
      h1.pb-6 Статус: {{ task_status_title }}
      div.pt-4(v-if="task_status == 'playing' || task_status == 'paused'")
        .my_bu_button(@click="taskHandler('restart')") Перезапустить сбор
      div.pt-4(v-else-if="task_status != 'need_to_start'")
        .my_bu_button(@click="taskHandler('start')") Запустить сбор
      div.pt-4(v-if="task_status == 'playing'")
        .my_bu_button(@click="taskHandler('pause')") Приостановить сбор
      div.pt-4(v-else-if="task_status == 'paused'")
        .my_bu_button(@click="taskHandler('play')") Возобновить сбор

      h1.pt-4 Осталось запросить: {{ tasks_quantity_remain }} из {{ tasks_quantity }}
  
      .pt-10
        .my_bu_button(@click="taskClearAll") Очистить всё
  
</template>

<script>

import { taskClearAll, taskInitialRequest, taskHandler } from "../api/index";
import { commonMixin } from "../shared/mixins";

export default {
  name: 'TaskPage',
  data () {
    return {
      task_status: null,
      tasks_quantity: null,
      tasks_quantity_now: null
    }
  },
  computed: {
    tasks_quantity_remain () {
      if (this.tasks_quantity_now) {
        return this.tasks_quantity_now;
      }
      return this.tasks_quantity;
    },
    task_status_title () {
      if (this.task_status == "paused") {
        return "Сбор на паузе"
      } else if (this.task_status == "playing") {
        return "Идёт сбор"
      } else if (this.task_status == "need_to_start") {
        return "Ожидает запуска"
      }
      return "Сбор не производится"
    }
  },
  mixins: [
    commonMixin  
  ],
  mounted () {
    this.initialRequest();
  },
  methods: {
    async initialRequest () {
      let token = this.getTokenFromCookies();
      let data = await taskInitialRequest(this, token);
      if (data) {
        this.task_status = data["task_status"];
        this.tasks_quantity = data["tasks_quantity"];
        this.tasks_quantity_now = data["tasks_quantity_now"];
        console.log(data);
      }
    },
    async taskHandler (val) {
      let token = this.getTokenFromCookies();
      let context = this;
      let data = {
        "task_command": val
      };
      let result = null;
      if (val == 'restart' || val == 'start') {
        context.$swal({
          "icon": "warning",
          "title": "Вы уверены?",
          "text": "Данное действие сотрёт все уже созданные записи в БД и начнёт сбор данных с самого начала",
          confirmButtonText: "Да, запустить сбор данных заново",
          showCancelButton: true,
          cancelButtonText: "Отмена"
        }).then(async function(isConfirm) {
          if (isConfirm.isConfirmed) {
            result = await taskHandler(data, token, context);
          }
        });
      } else {
        result = await taskHandler(data, token, context);
      }
      if (result) {
        this.task_status = result["task_status"];
        this.tasks_quantity = result["tasks_quantity"];
        this.tasks_quantity_now = result["tasks_quantity_now"];
      }
    },
    async taskClearAll () {
      let token = this.getTokenFromCookies();
      await taskClearAll(this, token);
    }
  }
}
</script>

<style lang="sass">

.my_bu_button
  display: inline-block
  padding: 20px
  border-radius: 5px
  background-color: #5585C1
  color: #fff
  cursor: pointer


</style>
